<template>
	<div class="bottom-navigation">
		<div class="row">
			<div class="col-11">
				<div class="row">
					<div class="col-6 pr-1">
						<slot name="left"></slot>
					</div>
					<div class="col-6 pl-1">
						<slot name="right"></slot>
					</div>
					<div class="col-12">
						<slot></slot>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "BottomNavigation",
		mounted() {
			this.$emit('new-height', this.$el.clientHeight)
		}
	}
</script>

<style scoped>

</style>
